"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8563],{

/***/ 82161:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PurpleFaDollarSign.8c7fcd0b.svg","height":24,"width":25});

/***/ }),

/***/ 90748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(53857);
;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/remote.tsx
var remote = {
    backgroundColor: 'purple.200',
    color: 'primary.500',
    textTransform: 'capitalize'
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/rawText.tsx
var rawText = {
    backgroundColor: 'purple.200',
    color: 'primary.500',
    textTransform: 'none'
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/index.tsx


var variants = {
    remote: remote,
    rawText: rawText
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/index.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Badge = function(_param) /*#__PURE__*/ {
    var _variant = _param.variant, variant = _variant === void 0 ? 'remote' : _variant, text = _param.text, _isClosable = _param.isClosable, isClosable = _isClosable === void 0 ? false : _isClosable, onClose = _param.onClose, props = _objectWithoutProperties(_param, [
        "variant",
        "text",
        "isClosable",
        "onClose"
    ]);
    return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Badge */.Ct, _objectSpread({
        fontWeight: 600,
        borderRadius: "base",
        fontSize: "xs",
        letterSpacing: "thight",
        px: 2,
        py: 1
    }, variants[variant], props, {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                children: text
            }),
            isClosable && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                _hover: {
                    textColor: 'black',
                    bgColor: '#00000010'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                    onClick: function(e) {
                        return onClose && onClose(e);
                    }
                })
            })
        ]
    }));
};



/***/ }),

/***/ 70579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ BadgeTech; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BadgeTech = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function(_param, ref) {
    var text = _param.text, textColor = _param.textColor, borderColor = _param.borderColor, hoverBgColor = _param.hoverBgColor, hoverTextColor = _param.hoverTextColor, props = _objectWithoutProperties(_param, [
        "text",
        "textColor",
        "borderColor",
        "hoverBgColor",
        "hoverTextColor"
    ]);
    var hoverBgColorToken = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useToken */ .dQ)('colors', hoverBgColor);
    var hoverTextColorToken = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useToken */ .dQ)('colors', hoverTextColor);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, _objectSpread({
        ref: ref,
        fontWeight: 700,
        textTransform: "uppercase",
        borderColor: borderColor,
        borderRadius: 6,
        borderStyle: "solid",
        borderWidth: 2.5,
        color: textColor,
        fontSize: "xs",
        letterSpacing: "widest",
        px: 2.5,
        py: 1,
        _hover: {
            bgColor: hoverBgColorToken,
            color: hoverTextColorToken
        }
    }, props, {
        children: text
    })));
});

BadgeTech.displayName = 'BadgeTech';


/***/ }),

/***/ 44085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FlagEnum; },
/* harmony export */   "A": function() { return /* binding */ CountryFlag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80241);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var lib_constants_translateNamespaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8366);




var FlagEnum;
(function(FlagEnum) {
    FlagEnum["en"] = 'en';
    FlagEnum["br"] = 'pt_BR';
    FlagEnum["usFlag"] = 'us_flag';
    FlagEnum["brFlag"] = 'br_flag';
})(FlagEnum || (FlagEnum = {}));
var CountryFlag = function(param) {
    var flag = param.flag, _height = param.height, height = _height === void 0 ? 25 : _height;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(lib_constants_translateNamespaces__WEBPACK_IMPORTED_MODULE_3__/* .TRANSLATE_NAMESPACES.global */ .V.global).t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: {
            position: 'relative',
            display: 'inline-block',
            height: "".concat(height, "px"),
            width: "".concat(height, "px")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
            src: "/flags/".concat(flag, ".png"),
            layout: "fill",
            alt: t("flag.".concat(flag))
        })
    }));
};


/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var fontSizes = {
    h4: [
        '14px',
        '14px',
        '16px',
        '16px'
    ],
    h3: [
        '16px',
        '16px',
        '20px',
        '20px'
    ],
    h2: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h1: [
        '36px',
        '36px',
        '36px',
        '36px'
    ]
};
var boostFontSizes = {
    h4: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h3: [
        '40px',
        '40px',
        '48px',
        '48px'
    ],
    h2: [
        '48px',
        '48px',
        '60px',
        '60px'
    ],
    h1: [
        '60px',
        '60px',
        '68px',
        '68px'
    ]
};
var fontWeights = {
    h4: '500',
    h3: '500',
    h2: '600',
    h1: '600'
};
var Heading = function(_param) /*#__PURE__*/ {
    var children = _param.children, _format = _param.format, format = _format === void 0 ? 'h1' : _format, _boostSizeLength = _param.boostSizeLength, boostSizeLength = _boostSizeLength === void 0 ? 0 : _boostSizeLength, _pt = _param.pt, pt = _pt === void 0 ? 2 : _pt, _mt = _param.mt, mt = _mt === void 0 ? 2 : _mt, props = _objectWithoutProperties(_param, [
        "children",
        "format",
        "boostSizeLength",
        "pt",
        "mt"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, _objectSpread({
        as: format,
        fontSize: boostSizeLength ? boostFontSizes[format] : fontSizes[format] || fontSizes.h1,
        fontWeight: fontWeights[format] || fontWeights.h1,
        letterSpacing: "1px",
        color: "text.100",
        lineHeight: "normal",
        "data-testid": "heading",
        pt: pt,
        mt: mt
    }, props, {
        children: boostSizeLength && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children.slice(0, boostSizeLength),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    display: "inline",
                    fontSize: fontSizes[format] || fontSizes.h1,
                    children: children.slice(boostSizeLength)
                })
            ]
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 9123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ SalaryRange; },
  "l": function() { return /* binding */ SalarySuffixTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
;// CONCATENATED MODULE: ./src/lib/utils/formatSalaryWithoutCurrency/index.ts
/**
 * Formats salary without currency and with decimals.
 * Example: 9.837,00
 *
 * @param salary {number | undefined}
 * @param decimals {number}
 *
 * @returns {string}
 */ var formatSalaryWithoutCurrency = function(salary) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var format = {
        minimumFractionDigits: decimals,
        currency: 'BRL'
    };
    if (!salary && salary !== 0) return '';
    return salary.toLocaleString('pt-BR', format);
};

;// CONCATENATED MODULE: ./src/components/atoms/salaryRange/index.tsx



var SalarySuffixTypes;
(function(SalarySuffixTypes) {
    SalarySuffixTypes["CLT"] = ' BRL/m\xeas';
    SalarySuffixTypes["PJ"] = ' BRL/m\xeas';
    SalarySuffixTypes["PJ_US"] = ' USD/ano';
    SalarySuffixTypes["None"] = '';
})(SalarySuffixTypes || (SalarySuffixTypes = {}));
var SalaryRange = function(param) {
    var minSalary = param.minSalary, maxSalary = param.maxSalary, currency = param.currency, suffix = param.suffix, _isFilter = param.isFilter, isFilter = _isFilter === void 0 ? false : _isFilter;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mr: 1,
                color: "text.700",
                children: currency
            }),
            formatSalaryWithoutCurrency(minSalary, 0),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mx: 1,
                color: isFilter ? 'primary.500' : undefined,
                children: "-"
            }),
            isFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mr: 1,
                color: "text.700",
                children: currency
            }) : null,
            formatSalaryWithoutCurrency(maxSalary, 0),
            suffix ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                ml: 1,
                color: "text.700",
                children: suffix
            }) : null
        ]
    });
};


/***/ }),

/***/ 48563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ JobCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34237);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80241);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75657);
/* harmony import */ var _public_icons_jobs_PurpleFaDollarSign_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82161);
/* harmony import */ var components_atoms_heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68590);
/* harmony import */ var components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90748);
/* harmony import */ var components_atoms_badgeTech__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70579);
/* harmony import */ var lib_utils_jobCard__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28611);
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29770);
/* harmony import */ var lib_utils_formatCity__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19266);
/* harmony import */ var components_atoms_countryFlag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44085);
/* harmony import */ var components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9123);
/* harmony import */ var lib_generated_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16402);














var JobCard = function(param) {
    var acceptRemote = param.acceptRemote, hybrid = param.hybrid, city = param.city, cltSalaryMin = param.cltSalaryMin, cltSalaryMax = param.cltSalaryMax, pjSalaryMin = param.pjSalaryMin, pjSalaryMax = param.pjSalaryMax, usdAnnualSalaryMin = param.usdAnnualSalaryMin, usdAnnualSalaryMax = param.usdAnnualSalaryMax, slug = param.slug, techs = param.techs, title = param.title, hideSalary = param.hideSalary, isInternational = param.isInternational, jobType = param.jobType, companySlug = param.companySlug;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        _hover: {
            boxShadow: 'sm'
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
            href: jobType === lib_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .JobTypeEnum.FullSupport */ .a_7.FullSupport ? lib_constants_paths__WEBPACK_IMPORTED_MODULE_11__/* .SLUG_JOB */ .M2(slug) : jobType === lib_generated_graphql__WEBPACK_IMPORTED_MODULE_9__/* .JobTypeEnum.Ats */ .a_7.Ats ? lib_constants_paths__WEBPACK_IMPORTED_MODULE_11__/* .ATS_SLUG_JOB */ .EU(companySlug, slug) : lib_constants_paths__WEBPACK_IMPORTED_MODULE_11__/* .V2_SLUG_JOB */ .ZG(companySlug, slug),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                h: "100%",
                flexDirection: "column",
                justifyContent: "space-between",
                bgColor: "white.100",
                cursor: "pointer",
                borderRadius: 3,
                px: {
                    base: 3,
                    lg: 7
                },
                py: 9,
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                format: "h3",
                                mt: 0,
                                pt: 0,
                                mb: 4,
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                fontSize: "xl",
                                lineHeight: 7,
                                letterSpacing: "tight",
                                color: "black.700",
                                children: title
                            }),
                            (city || acceptRemote) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                                mb: 5,
                                flexWrap: "wrap",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                                        mr: 2,
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_countryFlag__WEBPACK_IMPORTED_MODULE_7__/* .CountryFlag */ .A, {
                                                flag: isInternational ? components_atoms_countryFlag__WEBPACK_IMPORTED_MODULE_7__/* .FlagEnum.usFlag */ .$.usFlag : components_atoms_countryFlag__WEBPACK_IMPORTED_MODULE_7__/* .FlagEnum.brFlag */ .$.brFlag,
                                                height: 16
                                            }),
                                            city && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                                                ml: 2.5,
                                                fontSize: "md",
                                                color: "black.700",
                                                children: (0,lib_utils_formatCity__WEBPACK_IMPORTED_MODULE_12__/* .formatCity */ .H)(city)
                                            })
                                        ]
                                    }),
                                    !isInternational && (acceptRemote || hybrid) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                        variant: "remote",
                                        text: hybrid ? 'h\xedbrido' : 'remoto'
                                    }),
                                    isInternational && acceptRemote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                        variant: "remote",
                                        text: city ? 'h\xedbrido' : 'remoto'
                                    })
                                ]
                            }),
                            !hideSalary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                                flexDirection: "column",
                                gridGap: 0.5,
                                mb: 2.5,
                                children: [
                                    (cltSalaryMin > 0 || cltSalaryMax > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .rj, {
                                        justifyContent: "start",
                                        alignItems: "center",
                                        templateColumns: "repeat(3, auto)",
                                        columnGap: 2.5,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                pt: "2px",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    src: _public_icons_jobs_PurpleFaDollarSign_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                                    alt: "Dollar sign icon",
                                                    height: "16px",
                                                    width: "16px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                gridColumnStart: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalaryRange */ .m, {
                                                    minSalary: cltSalaryMin,
                                                    maxSalary: cltSalaryMax,
                                                    currency: "R$",
                                                    suffix: components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalarySuffixTypes.CLT */ .l.CLT
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                    text: "CLT"
                                                })
                                            })
                                        ]
                                    }),
                                    (pjSalaryMin > 0 || pjSalaryMax > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .rj, {
                                        justifyContent: "start",
                                        alignItems: "center",
                                        templateColumns: "repeat(3, auto)",
                                        columnGap: 2.5,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                pt: "2px",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    src: _public_icons_jobs_PurpleFaDollarSign_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                                    alt: "Dollar sign icon",
                                                    height: "16px",
                                                    width: "16px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                gridColumnStart: [
                                                    2,
                                                    2
                                                ],
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalaryRange */ .m, {
                                                    minSalary: pjSalaryMin,
                                                    maxSalary: pjSalaryMax,
                                                    currency: "R$",
                                                    suffix: components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalarySuffixTypes.PJ */ .l.PJ
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                    variant: "rawText",
                                                    text: "PJ ou Cooperativa"
                                                })
                                            })
                                        ]
                                    }),
                                    (usdAnnualSalaryMin > 0 || usdAnnualSalaryMax > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .rj, {
                                        justifyContent: "start",
                                        templateColumns: "repeat(3, auto)",
                                        alignItems: "center",
                                        columnGap: 2.5,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                pt: "2px",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                    src: _public_icons_jobs_PurpleFaDollarSign_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                                    alt: "Dollar sign icon",
                                                    height: "16px",
                                                    width: "16px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                gridColumnStart: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalaryRange */ .m, {
                                                    minSalary: usdAnnualSalaryMin,
                                                    maxSalary: usdAnnualSalaryMax,
                                                    currency: "US$",
                                                    suffix: components_atoms_salaryRange__WEBPACK_IMPORTED_MODULE_8__/* .SalarySuffixTypes.PJ_US */ .l.PJ_US
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .GridItem */ .P4, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badge__WEBPACK_IMPORTED_MODULE_5__/* .Badge */ .C, {
                                                    variant: "rawText",
                                                    text: "PJ ou Cooperativa"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                                color: "text.100",
                                align: "center",
                                flexWrap: "wrap",
                                mb: 8,
                                children: (0,lib_utils_jobCard__WEBPACK_IMPORTED_MODULE_13__/* .formatTechs */ .W)(techs).map(function(tech) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        href: "/vagas-:tech",
                                        as: tech.urlPath,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_badgeTech__WEBPACK_IMPORTED_MODULE_6__/* .BadgeTech */ .T, {
                                            text: tech.name,
                                            borderColor: "primary.500",
                                            hoverBgColor: "primary.500",
                                            hoverTextColor: "white.100",
                                            textColor: "primary.500",
                                            mr: 3.5,
                                            mb: 2
                                        })
                                    }, tech.name);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .xv, {
                        p: 2,
                        w: "fit-content",
                        cursor: "pointer",
                        color: "primary.500",
                        fontFamily: "'Poppins', sans-serif",
                        textDecor: "underline",
                        fontWeight: 400,
                        letterSpacing: "widest",
                        _hover: {
                            backgroundColor: 'primary.100',
                            borderRadius: 'base'
                        },
                        children: "Visualizar vaga"
                    })
                ]
            })
        })
    });
};



/***/ }),

/***/ 19266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ formatCity; }
/* harmony export */ });
/**
 * format city name replacing ' -' for ','
 *
 * @param cityWithState
 * @returns {string}
 */ var formatCity = function(city) {
    return city.replace(/\s-(?=[^-]*$)/, ',');
};


/***/ }),

/***/ 28611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ formatTechs; }
/* harmony export */ });
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29770);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var formatTechs = function(techs) {
    var displayTechs = techs.slice(0, 3).map(function(tech) {
        var result = _objectSpread({}, tech);
        result.urlPath = lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .TECHS_JOBS */ .uT(tech.urlPath);
        return result;
    });
    if (techs.length > 3) {
        displayTechs.push({
            name: "+ ".concat(techs.length - 3),
            urlPath: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .JOBS */ .WN
        });
    }
    return displayTechs;
};


/***/ })

}]);